import "@/App.css";
import { Header } from "./components/site/Header";
import { Hero } from "./components/site/Hero";
import { LatestRelease } from "./components/site/LatestRelease";
import { Archive } from "./components/site/Archive";
import { About } from "./components/site/About";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";

function App() {
  return (
    <div
      data-testid="site-root"
      className="kv-grain min-h-screen bg-[#080808] text-[#f2f0e9] selection:bg-[#f2f0e9]/20"
    >
      <Header />
      <main>
        <Hero />
        <LatestRelease />
        <Archive />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
